import { CircularProgress, Paper, Typography } from '@mui/material';
import {
  NotificationTypeEnum,
  useNotification,
} from '@prismamedia/one-components';
import { FC, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { paths } from '../../routing/Router/paths';
import { loginWithAzureIdToken } from '../../utils/auth';
import { getAzureIdTokenFromRedirect } from '../../utils/azureAuth';
import { useStyles } from './styles';

export const AzureCallback: FC = () => {
  const classes = useStyles();
  const history = useHistory();
  const { pushNotification } = useNotification();

  useEffect(() => {
    const completeAzureLogin = async () => {
      try {
        const idToken = await getAzureIdTokenFromRedirect();
        if (!idToken) {
          throw new Error('Erreur de connexion');
        }
        const jwt = await loginWithAzureIdToken(idToken);
        if (!jwt) {
          throw new Error('Erreur de connexion');
        }
        history.replace(paths.ARTICLE_LIST);
      } catch (error) {
        pushNotification({
          message:
            error instanceof Error ? error.message : 'Erreur de connexion',
          type: NotificationTypeEnum.error,
        });
        history.replace(paths.LOGIN);
      }
    };

    void completeAzureLogin();
  }, [history, pushNotification]);

  return (
    <div className={classes.wrapperBackgroundImage}>
      <Paper className={classes.wrapperLogin}>
        <CircularProgress />
        <Typography className={classes.callbackMessage}>
          Connexion Microsoft en cours…
        </Typography>
      </Paper>
    </div>
  );
};
